import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce5b79b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_3 = {
  key: 0,
  class: "is-danger-message"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_6 = {
  key: 1,
  class: "is-danger-message"
}


const __default__ = {
  name: "BatchSegmentFieldConfiguration",
};
import { computed, watch } from "vue";
import { useField } from "vee-validate";
import { UseValidateHelper } from "../../../Helper/Functional/UseValidateHelper";
import { UseUpload } from "../../../Pages/SegmentManagement/Uploads/Hooks/UseUpload";


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { configuration, availableColumns, showLastStep } = UseUpload();

const orderCompute = computed(() => configuration.order_id);
const segmentCompute = computed(() => configuration.segment);

const mandatoryData = computed(
  () => !!segmentCompute.value.value && !!orderCompute.value.value
);

const updateConfigurationValue = (key: "order_id" | "segment", e: Event) => {
  const val = (e.target as HTMLInputElement).value;
  configuration[key].value = val;
};

//Form stuff

const { isRequired } = UseValidateHelper();
const { errorMessage, value: orderIdValidation } = useField<string | null>(
  "order_id",
  isRequired("This field is required")
);
const { errorMessage: errorMessageSegment, value: orderSegmentValidation } = useField<
  string | null
>("segment", isRequired("This field is required"));

watch(
  [() => ({ ...orderCompute.value }), () => ({ ...segmentCompute.value })],
  ([newId, newSeg], [oldId, oldSeg]) => {
    if (newId !== oldId) {
      orderIdValidation.value = newId.value;
    }
    if (newSeg !== oldSeg) {
      orderSegmentValidation.value = newSeg.value;
    }
  }
);

watch(mandatoryData, (val: boolean) => {
  showLastStep.value = val;
});

return (_ctx: any,_cache: any) => {
  const _component_o_switch = _resolveComponent("o-switch")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_select = _resolveComponent("o-select")!
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_button = _resolveComponent("o-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_o_field, { grouped: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_o_field, { label: "Order *" }, {
          default: _withCtx(() => [
            _createVNode(_component_o_switch, {
              modelValue: _unref(configuration).order_id.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(configuration).order_id.type) = $event)),
              variant: _unref(orderCompute).value ? 'success' : 'primary',
              "true-value": "dynamic",
              "false-value": "static",
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(configuration).order_id.value = ''))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(orderCompute).type === "dynamic" ? "Dynamic" : "Static"), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "variant"])
          ]),
          _: 1
        }),
        (_unref(orderCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 0,
              label: "Column"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_select, {
                  name: "order_id",
                  "data-vv-name": "order_id",
                  modelValue: _unref(configuration).order_id.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(configuration).order_id.value) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableColumns), (col) => {
                      return (_openBlock(), _createElementBlock("option", { value: col }, _toDisplayString(col), 9, _hoisted_1))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(orderCompute).type === 'static')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 1,
              label: "Static Value"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_input, {
                  onInput: _cache[3] || (_cache[3] = (e) => updateConfigurationValue('order_id', e)),
                  name: "order_id",
                  "data-vv-name": "order_id",
                  placeholder: _unref(configuration).order_id.value
                }, null, 8, ["placeholder"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(orderCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 2,
              class: "align-self-flex-end"
            }, {
              label: _withCtx(() => [
                _hoisted_2
              ]),
              default: _withCtx(() => [
                _createVNode(_component_o_button, {
                  disabled: _unref(orderCompute).value === '',
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(configuration).order_id.value = '')),
                  variant: "danger",
                  "icon-left": "close"
                }, null, 8, ["disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_unref(errorMessage)), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_o_field, { grouped: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_o_field, { label: "Segment" }, {
          default: _withCtx(() => [
            _createVNode(_component_o_switch, {
              onInput: _cache[5] || (_cache[5] = ($event: any) => (_unref(configuration).segment.value = '')),
              variant: _unref(segmentCompute).value ? 'success' : 'primary',
              "true-value": "dynamic",
              "false-value": "static",
              modelValue: _unref(configuration).segment.type,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(configuration).segment.type) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(segmentCompute).type === "dynamic" ? "Dynamic" : "Static"), 1)
              ]),
              _: 1
            }, 8, ["variant", "modelValue"])
          ]),
          _: 1
        }),
        (_unref(segmentCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 0,
              label: "Column"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_select, {
                  name: "segment",
                  modelValue: _unref(configuration).segment.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(configuration).segment.value) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableColumns), (col) => {
                      return (_openBlock(), _createElementBlock("option", { value: col }, _toDisplayString(col), 9, _hoisted_4))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(segmentCompute).type === 'static')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 1,
              label: "Static Value"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_input, {
                  onInput: _cache[8] || (_cache[8] = (e) => updateConfigurationValue('segment', e)),
                  placeholder: _unref(configuration).segment.value
                }, null, 8, ["placeholder"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(segmentCompute).type === 'dynamic')
          ? (_openBlock(), _createBlock(_component_o_field, {
              key: 2,
              class: "align-self-flex-end"
            }, {
              label: _withCtx(() => [
                _hoisted_5
              ]),
              default: _withCtx(() => [
                _createVNode(_component_o_button, {
                  disabled: _unref(segmentCompute).value === '',
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(configuration).segment.value = '')),
                  variant: "danger",
                  "icon-left": "close"
                }, null, 8, ["disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(errorMessageSegment))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_unref(errorMessageSegment)), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})